import CloseIcon from '@mui/icons-material/Close';
import { Theme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import { ModalWithStyles } from './ModalWithStyles';

const useStyles = makeStyles((theme: Theme) => ({
  customWidth: {
    '& .MuiPaper-root.MuiDialog-paper': {
      maxWidth: '760px',
      top: '100px',
      overflow: 'visible',
    },
  },
  centerDisplay: {
    display: 'flex',
    justifyContent: 'center',
  },
  title1: {
    fontSize: '22px',
    fontWeight: 600,
  },
  title2: {
    fontSize: '36px',
    fontWeight: 600,
  },
  titlePadding1: {
    margin: '16px 0px 24px',
    maxWidth: '470px',
  },
  titlePadding2: {
    margin: '12px 0px 48px',
  },
  subtitle1: {
    fontSize: '12px',
    fontWeight: 500,
  },
  subtitle2: {
    fontSize: '16px',
    fontWeight: 600,
  },
  modalContainer: {
    padding: '0px 24px',
  },
  closeButton: {},
  closeButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '48px',
  },
  checkmarkIcon: {
    height: '64px',
    width: '64px',
    backgroundColor: theme.palette.success.main,
    borderRadius: '50%',
    padding: '4px',
    color: 'white',
  },
  checkmarkIconContainer: {
    position: 'relative',
    left: '208px',
    top: '32px',
    zIndex: 3,
  },
  checkedOverlay: {
    position: 'absolute',
    borderRadius: '8px',
    // cursor: 'pointer',
    backgroundColor: 'rgba(175,185,195,0.5)',
    height: '330px',
    width: '240px',
    zIndex: 2,
  },
  kixieIconContainer: {
    padding: '28px',
    width: '128px',
    height: '128px',
    position: 'relative',
    top: '-84px',
    display: 'flex',
    zIndex: 1301,
    borderRadius: '50%',
    backgroundColor:
      theme.palette.mode === 'light' ? 'white' : 'rgb(66, 66, 66)',
    justifyContent: 'center',
  },
  newTrialModalContainer: {
    position: 'absolute',
    borderRadius: '16px',
    maxWidth: '75%',
    width: '800px',
    zIndex: 100,
    top: '64px',
    backgroundColor: theme.palette.mode === 'light' ? 'white' : 'white',
    boxShadow:
      '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
  },
  imageColumnContainer: {
    position: 'relative',
  },
}));

const KIXIE_ICON_IMG = toAbsoluteUrl('/media/logos/Kixie-Logo-Bubble-Red.png');
const GET_ONBOARDING_IMG = toAbsoluteUrl('/media/logos/require-onboarding.png');
const GET_INSTALL_POWERCALL_IMG = toAbsoluteUrl(
  '/media/logos/require-powercall.png'
);

const CheckMarkIcon = (props: { hidden: boolean }) => {
  const classes = useStyles();

  return (
    <div className={classes.checkmarkIconContainer}>
      <img
        alt="Checkmark Icon"
        style={{
          height: '56px',
          width: '56px',
          borderRadius: '50%',
          display: props.hidden ? 'none' : 'block',
        }}
        src={toAbsoluteUrl('/media/logos/checkmark.png')}
      />
      {/* <CheckIcon className={classes.checkmarkIcon} /> */}
    </div>
  );
};

export function NewTrialModal({
  show,
  handleClose,
  requireOnboarding,
  requirePowerCall,
}) {
  const classes = useStyles();
  const history = useHistory();

  const openPowerCallChromeStoreUrl = () => {
    window.open(
      'https://d2qcdq04.na1.hubspotlinks.com/Ctc/UB+113/d2qCdQ04/VWwGWD95-XBkN1wYbSjLpW1qVcSh174TQtXTN3V8l9V3q90JV1-WJV7CgX8CW2XG3RJ2gYB5rW2zbQXr8shYs4W1Z4D2T8xj6Y4W6qH9fr8y1c2hW8JCWxz78cJ7XW8Njh1W3bxhYjW90dBZZ2sq0rlW3MQZcZ6qZf93W8bjF8Z5WzJj1W5FPQgt9k0nynN8yZDw5Mv6BLW6nj4917V8k_yW3xDJxH8T2R8RW3xyhl_8T1PpKW5DxSQ-48sXJtW4g05m47PDr7GVXDj7V8T_Rg1W3JhD9h1CVY5jW38SDmB5qrMTBW6Vgkp45k3vLKW1yvGmm1xC7PGW2SK3qT21s5jMW1GpmtJ9hT0FJW7mB-7g2hD0l-W3LNwnC76wL2dW2Fxygn7ZRFf-MPrj6DKDLSnW6svDR95FbW7V3g4V1'
    );
  };

  const redirectToOnboardingWalkthrough = () => {
    handleClose();
    history.push({
      pathname: '/onboarding-walkthrough',
      search: location.search,
    });
  };

  return (
    <ModalWithStyles
      className={classes.customWidth}
      show={show}
      hideFooter={true}
      hideHeader={true}
      nonScroll={true}
      title=""
      onHide={() => {
        handleClose();
      }}
      isSubmitting={false}
      size={'sm'}
    >
      <div className={classes.closeButtonContainer}>
        <div style={{ width: '43.5px' }} />
        <div className={classes.kixieIconContainer}>
          <img
            alt="Kixie Icon"
            style={{ height: '80px', width: '80px' }}
            src={KIXIE_ICON_IMG}
          />
        </div>
        <IconButton onClick={handleClose} size="large">
          <CloseIcon fontSize="inherit" className={classes.closeButton} />
        </IconButton>
      </div>
      <div className={classes.modalContainer}>
        <div className={classes.centerDisplay}>
          {requirePowerCall && requireOnboarding ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div className={clsx(classes.title1, classes.centerDisplay)}>
                Welcome to your free 7-day trial of Kixie
              </div>
              <div
                className={clsx(
                  classes.subtitle1,
                  classes.titlePadding1,
                  classes.centerDisplay
                )}
              >
                Unlock a full suite of sales engagement tools, seamlessly synced
                with your CRM. Get started calling, texting, and integrating in
                minutes by following the links below.
              </div>
            </div>
          ) : requirePowerCall ? (
            <div>
              <div className={clsx(classes.title1, classes.centerDisplay)}>
                Welcome Back!
              </div>
              <div
                className={clsx(
                  classes.subtitle2,
                  classes.centerDisplay,
                  classes.titlePadding2
                )}
              >
                Now let's finish getting PowerCall installed.
              </div>
            </div>
          ) : requireOnboarding ? (
            <div>
              <div className={clsx(classes.title1, classes.centerDisplay)}>
                Welcome Back!
              </div>
              <div
                className={clsx(
                  classes.subtitle2,
                  classes.centerDisplay,
                  classes.titlePadding2
                )}
              >
                Now let's finish setting up your business.
              </div>
            </div>
          ) : (
            <div>
              <div className={clsx(classes.title1, classes.centerDisplay)}>
                Welcome Back!
              </div>
              <div
                className={clsx(
                  classes.subtitle2,
                  classes.centerDisplay,
                  classes.titlePadding2
                )}
              >
                You are set up.
              </div>
            </div>
          )}
        </div>
        <div
          style={{ alignItems: 'center', justifyContent: 'space-evenly' }}
          className="row"
        >
          <div
            style={{ top: requirePowerCall ? '-20px' : '-48px' }}
            className={classes.imageColumnContainer}
          >
            {<CheckMarkIcon hidden={requirePowerCall} />}
            {!requirePowerCall && <div className={classes.checkedOverlay} />}
            <img
              onClick={openPowerCallChromeStoreUrl}
              style={{
                borderRadius: '8px',
                height: '330px',
                width: '240px',
                cursor: 'pointer',
              }}
              alt="logo"
              src={GET_INSTALL_POWERCALL_IMG}
            />
          </div>
          <div
            style={{ top: requireOnboarding ? '-20px' : '-48px' }}
            className={classes.imageColumnContainer}
          >
            {<CheckMarkIcon hidden={requireOnboarding} />}
            {!requireOnboarding && <div className={classes.checkedOverlay} />}
            <img
              onClick={redirectToOnboardingWalkthrough}
              style={{
                borderRadius: '8px',
                height: '330px',
                width: '240px',
                cursor: 'pointer',
              }}
              alt="logo"
              src={GET_ONBOARDING_IMG}
            />
          </div>
        </div>
      </div>
    </ModalWithStyles>
  );
}
